import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';

const WhoopPuckAttribution: React.FC = () => {
    const { isDark } = useTheme();
    const puckLogo = isDark
        ? '/logos/whoop/Logo/Circle/WHOOP Circle White.svg'
        : '/logos/whoop/Logo/Circle/WHOOP Circle Black.svg';

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'end', // right-align
                margin: 16,
                width: '100%',
                boxSizing: 'border-box',
            }}
        >
            <img
                src={puckLogo}
                alt="WHOOP Puck Logo"
                style={{ width: 30, height: 30, marginRight: 6, opacity: 0.85, padding: 0 }} // small margin between logo and text
            />
            <span
                className="cgm-text-primary"
                style={{
                    fontSize: 10,
                    fontWeight: 600,
                    letterSpacing: '0.05em',
                    opacity: 0.85,
                    textShadow: isDark ? '0 1px 2px #000' : '0 1px 2px #fff',
                    padding: 0, // no extra padding
                }}
            >
                Data powered by WHOOP
            </span>
        </div>
    );
};

export default WhoopPuckAttribution; 